import * as actionTypes from "./SettingsTypes";

const INITIAL_STATE = {
    sourceList: [],
    stageList: [],
    verticalList: [],
    statusList: [],
    taskStatusList: [],
    userRolesList: [],
    roleAuthorizationList: [],
    authorizedPages: [],
    userList: [],
    userData: {},
    advanceSeriesList: [],
    advanceSetting: null,
    accountList: [],
    projectTypeList: [],
    projectStatusList: [],
    ticketLevelList: [],
    ticketPriorityList: [],
    ticketStatusList: [],
    departmentList: [],
    departmentDetail: null,
    notificationList: [],
    historyList: [],
    tktReviewList: [],
    divisionList: [],
    divisionAdminAccessList: [],
    userEmailList: [],
    timeZonesList: [],
    rootCauseList: [],
    skillsList: [],
    organisationLevelsList: [],
    userDepartmentsList: [],
    clustersList: [],
    leaveWfhMasterList: [],
};

const SalesQuoteReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETSOURCELIST:
            return {
                ...state,
                sourceList: action.payload.list,
            };
        case actionTypes.SETSTAGELIST:
            return {
                ...state,
                stageList: action.payload.list,
            };
        case actionTypes.SETVERTICALLIST:
            return {
                ...state,
                verticalList: action.payload.list,
            };
        case actionTypes.SETSTATUSLIST:
            return {
                ...state,
                statusList: action.payload.list,
            };
        case actionTypes.SETTASKSTATUSLIST:
            return {
                ...state,
                taskStatusList: action.payload.list,
            };
        case actionTypes.SETUSERROLESLIST:
            return {
                ...state,
                userRolesList: action.payload.list,
            };
        case actionTypes.SETROLEAUTHORIZATIONLIST:
            return {
                ...state,
                roleAuthorizationList: action.payload.list,
            };
        case actionTypes.SETAUTHORIZEDPAGES:
            return {
                ...state,
                authorizedPages: action.payload.list,
            };
        case actionTypes.SETUSERLIST:
            return {
                ...state,
                userList: action.payload.list,
            };
        case actionTypes.SET_USER_DATA:
            return {
                ...state,
                userData: action.payload.list,
            };
        case actionTypes.SETADVANCESERIESLIST:
            return {
                ...state,
                advanceSeriesList: action.payload.list,
            };
        case actionTypes.SETADVANCESETTING:
            return {
                ...state,
                advanceSetting: action.payload.list,
            };
        case actionTypes.SETACCOUNTLIST:
            return {
                ...state,
                accountList: action.payload.list,
            };
        case actionTypes.SETPROJECTTYPELIST:
            return {
                ...state,
                projectTypeList: action.payload.list,
            };
        case actionTypes.SETPROJECTSTATUSLIST:
            return {
                ...state,
                projectStatusList: action.payload.list,
            };
        case actionTypes.SETTICKETLEVELLIST:
            return {
                ...state,
                ticketLevelList: action.payload.list,
            };
        case actionTypes.SETTICKETPRIORITYLIST:
            return {
                ...state,
                ticketPriorityList: action.payload.list,
            };
        case actionTypes.SETTICKETSTATUSLIST:
            return {
                ...state,
                ticketStatusList: action.payload.list,
            };
        case actionTypes.SETDEPARTMENTLIST:
            return {
                ...state,
                departmentList: action.payload.list,
            };
        case actionTypes.SETTICKETREVIEWLIST:
            return {
                ...state,
                tktReviewList: action.payload.list,
            };
        case actionTypes.SETDEPARTMENTDETAIL:
            return {
                ...state,
                departmentDetail: action.payload.list,
            };
        case actionTypes.CLEARDOC:
            return {
                ...state,
                departmentDetail: null,
            };
        case actionTypes.SETNOTIFICATIONLIST:
            return {
                ...state,
                notificationList: action.payload.list,
            };
        case actionTypes.SETHISTORYLIST:
            return {
                ...state,
                historyList: action.payload.list,
            };
        case actionTypes.SET_DIVISION_LIST:
            return {
                ...state,
                divisionList: action.payload.list,
            };
        case actionTypes.SET_DIVISION_ADMIN_ACCESS_LIST:
            return {
                ...state,
                divisionAdminAccessList: action.payload.list,
            };
        case actionTypes.SET_USER_EMAIL_LIST:
            return {
                ...state,
                userEmailList: action.payload.list,
            };
        case actionTypes.SET_TIME_ZONES_LIST:
            return {
                ...state,
                timeZonesList: action.payload.list,
            };
        case actionTypes.SET_ROOT_CAUSE_LIST:
            return {
                ...state,
                rootCauseList: action.payload.list,
            };
        case actionTypes.SET_SKILLS_LIST:
            return {
                ...state,
                skillsList: action.payload.list,
            };
        case actionTypes.SET_ORGANISATION_LEVELS_LIST:
            return {
                ...state,
                organisationLevelsList: action.payload.list,
            };
        case actionTypes.SET_USER_DEPARTMENTS_LIST:
            return {
                ...state,
                userDepartmentsList: action.payload.list,
            };
        case actionTypes.SET_CLUSTERS_LIST:
            return {
                ...state,
                clustersList: action.payload.list,
            };
        case actionTypes.SET_LEAVE_WFH_MASTER_LIST:
            return {
                ...state,
                leaveWfhMasterList: action.payload.list,
            };
        default:
            return state;
    };
};

export default SalesQuoteReducer;